// libraries.
import { Form, Row, Col } from "react-bootstrap";
import { UseFormRegister, FieldErrors } from "react-hook-form";

// styles.
import { StyledRulesModalForm } from "../../styles";

// types.
import { EditStepFormValues, categoryOptions } from "./useEditStepForm";

interface Props {
  register: UseFormRegister<EditStepFormValues>;
  errors: FieldErrors<EditStepFormValues>;
  dayRangeFrom: number;
}

export const EditStepFields = ({ register, errors, dayRangeFrom }: Props) => (
  <StyledRulesModalForm className="d-flex flex-column gap-3">
    <Row className="g-3">
      <Col xs={8}>
        <Form.Group>
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            size="sm"
            placeholder="Ej: Día 90"
            {...register("name", { required: "Requerido" })}
            isInvalid={!!errors.name}
          />
          <Form.Control.Feedback type="invalid">
            {errors.name?.message}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>

      <Col xs={4}>
        <Form.Group>
          <Form.Label>Categoría</Form.Label>
          <Form.Select
            size="sm"
            {...register("category", { required: "Requerido" })}
            isInvalid={!!errors.category}
          >
            {categoryOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>

    <Row className="g-3">
      <Col xs={4}>
        <Form.Group>
          <Form.Label>Día inicio</Form.Label>
          <Form.Control
            type="number"
            size="sm"
            placeholder="Ej: 90"
            min={0}
            {...register("dayRangeFrom", {
              required: "Requerido",
              valueAsNumber: true,
              min: { value: 0, message: "Debe ser ≥ 0" },
            })}
            isInvalid={!!errors.dayRangeFrom}
          />
          <Form.Control.Feedback type="invalid">
            {errors.dayRangeFrom?.message}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>

      <Col xs={4}>
        <Form.Group>
          <Form.Label>
            Día fin{" "}
            <span style={{ fontSize: 11, opacity: 0.6 }}>
              (vacío = sin límite)
            </span>
          </Form.Label>
          <Form.Control
            type="number"
            size="sm"
            placeholder="Sin límite"
            min={0}
            {...register("dayRangeTo", {
              valueAsNumber: false,
              validate: (val) => {
                if (val === "" || val === null || val === undefined) return true;
                const num = Number(val);
                if (isNaN(num)) return "Debe ser un número";
                if (num <= Number(dayRangeFrom))
                  return "Debe ser mayor al día inicio";
                return true;
              },
            })}
            isInvalid={!!errors.dayRangeTo}
          />
          <Form.Control.Feedback type="invalid">
            {errors.dayRangeTo?.message}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>

      <Col xs={4}>
        <Form.Group>
          <Form.Label>Ajuste</Form.Label>
          <Form.Control
            size="sm"
            placeholder="Ej: -3%, Bono 2%"
            {...register("adjustment", { required: "Requerido" })}
            isInvalid={!!errors.adjustment}
          />
          <Form.Control.Feedback type="invalid">
            {errors.adjustment?.message}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
    </Row>

    <Form.Group>
      <Form.Label>Descripción</Form.Label>
      <Form.Control
        as="textarea"
        rows={2}
        size="sm"
        placeholder="Describe el comportamiento de este paso"
        {...register("description", { required: "Requerido" })}
        isInvalid={!!errors.description}
      />
      <Form.Control.Feedback type="invalid">
        {errors.description?.message}
      </Form.Control.Feedback>
    </Form.Group>

    <Form.Group>
      <Form.Label>Detalles técnicos</Form.Label>
      <Form.Control
        as="textarea"
        rows={2}
        size="sm"
        placeholder="Detalles del cálculo o condiciones adicionales"
        {...register("details", { required: "Requerido" })}
        isInvalid={!!errors.details}
      />
      <Form.Control.Feedback type="invalid">
        {errors.details?.message}
      </Form.Control.Feedback>
    </Form.Group>

    <Form.Group>
      <Form.Check
        type="switch"
        id="modifiesPrice"
        label="Modifica precios"
        {...register("modifiesPrice")}
      />
    </Form.Group>
  </StyledRulesModalForm>
);

